query LookupDepotAreaSearch(
  $lookupCountryId: Int!
  $lookupDepot: String!
  $first: Int
  $isAirport: Boolean
  $isTrain: Boolean
  $isBus: Boolean
  $orderBy: [DepotsOrderBy!]
  $after: Cursor
) {
  lookupDepotAreaSearch(
    lookupCountryId: $lookupCountryId
    lookupDepot: $lookupDepot
    first: $first
    isAirport: $isAirport
    isTrain: $isTrain
    isBus: $isBus
    orderBy: $orderBy
    after: $after
  ) {
    nodes {
      id
      description
      cityArea
      stateRegion
      isTrainDepot
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
